<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3213_102204)">
<path d="M14.1933 7.9267L16.2474 10.5462C16.4439 10.7968 16.4439 11.2032 16.2474 11.4538L14.1933 14.0733" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
<rect x="1.85" y="4.76473" width="18.3" height="12.4705" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
</g>
<defs>
<clipPath id="clip0_3213_102204">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
